import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { userResponse } from 'src/app/models/userModel/userResponse';
import { userRoleResponse } from 'src/app/models/userModel/userRoleResponse';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private base = environment.urlServerApi+'users';

  constructor(private _http: HttpClient) {
  }

  getUsers(): Observable<userResponse>{
    return this._http.get<userResponse>(`${this.base}`)
  }

  getRoles(): Observable<userRoleResponse>{
    return this._http.get<userRoleResponse>(`${this.base}/roles`)
  }
}
